<template>
    <div>
        <app-gridview
            v-bind:parentData = "{
                tabHeaders: this.dataHeader,
                tabItems: this.dataItems,
                pageTitle: this.pageTitle,
                search: this.search,
            }"
            v-on:EditItem="editItemHandler($event)"
            v-on:DeleteItem="deleteItemHandler($event)"
            v-on:NewPressed="newRecordHandler"
        ></app-gridview>
    </div>
</template>

<script>
// import moment from 'moment';

import GridView from '../../../components/common/GridView';

export default {
    components: {
        'app-gridview': GridView
    },  
    
    data() {
        return {
            pageTitle: this.$t('arrearsexercise.arrearstransaction'),
            dataHeader: [
                {text: this.$t('columns.actions'), value: 'action', sortable: false,width:'80px'},
                {text: this.$t('arrearsexercise.bpexercisecode'), value: 'bpexercisecode', width: '100px'},
                {text: this.$t('arrearsexercise.bpexercisedesc'), value: 'bpexercisedesc', width: '150px'},
                {text: this.$t('columns.name'), value: 'psnname', width: '130px'},
                {text: this.$t('columns.staffno'), value: 'staffcode', width: '130px'},
                {text: this.$t('columns.company'), value: 'compnycode', width: '130px'},
                {text: this.$t('setupclaim.payitem'), value: 'payitemcode', width: '100px'},
                {text: this.$t('arrearsexercise.payout'), value: 'oripocode', width: '200px'},
                {text: this.$t('arrearsexercise.pyyear'), value: 'oripoyear', width: '50px'},
                {text: this.$t('arrearsexercise.pymonth'), value: 'oripomth', width: '50px'},
                {text: this.$t('recassetrec.quantity'), value: 'quantity', width: '50px'},
                {text: this.$t('arrearsexercise.oldamt'), value: 'oldamt', width: '50px'},
                {text: this.$t('arrearsexercise.newamt'), value: 'newamt', width: '50px'},
                {text: this.$t('arrearsexercise.diffamt'), value: 'diffamt', width: '50px'},
                {text: this.$t('columns.currency'), value: 'crcycode', width: '50px'},
                {text: this.$t('arrearsexercise.included'), value: 'topay', width: '50px'},
                {text: this.$t('arrearsexercise.posted'), value: 'posted', width: '50px'},
                {text: this.$t('arrearsexercise.posttopayout'), value: 'payoutdesc', width: '50px'},
            ],
            dataItems: [],
            errMsg: '',
            search: this.$route.params.search,
        }
    },

    methods: {
        loadArrearsExercises() {
            const vm = this;

            this.$store.dispatch('get', {url: '/arrearstransaction/all'})
            .then(res => {
                vm.dataItems = res.data.rec;
            })
            .catch(err => {
                vm.errMsg = err;
            });
        },

        editItemHandler(item) {
            this.$router.push({name: 'arrearstransactionedit', params: { id: item.id, search: item.search } });
        },

        newRecordHandler() {
            this.$router.push({name: 'arrearstransactionnew'});
        }
    },

    mounted() {
        this.loadArrearsExercises();
    }
}
</script>